export const layoutsSvgPreviews = {
  twoHorizontal: (
    <svg
      width="200"
      height="300"
      viewBox="0 0 200 300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="198"
        height="298"
        fill="none"
        stroke="black"
        stroke-width="2"
        rx="0"
        ry="0"
      />
      <line x1="1" y1="150" x2="199" y2="150" stroke="black" stroke-width="2" />
    </svg>
  ),
  threeHorizontal: (
    <svg
      width="200"
      height="300"
      viewBox="0 0 200 300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="198"
        height="298"
        fill="none"
        stroke="black"
        stroke-width="2"
        rx="0"
        ry="0"
      />
      <line x1="1" y1="100" x2="199" y2="100" stroke="black" stroke-width="2" />
      <line x1="1" y1="200" x2="199" y2="200" stroke="black" stroke-width="2" />
    </svg>
  ),
  threeBottomTriangle: (
    <svg
      width="200"
      height="300"
      viewBox="0 0 200 300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="198"
        height="298"
        fill="none"
        stroke="black"
        stroke-width="2"
        rx="0"
        ry="0"
      />
      <line x1="1" y1="150" x2="199" y2="150" stroke="black" stroke-width="2" />
      <line
        x1="100"
        y1="150"
        x2="100"
        y2="299"
        stroke="black"
        stroke-width="2"
      />
    </svg>
  ),
  threeTopTriangle: (
    <svg
      width="200"
      height="300"
      viewBox="0 0 200 300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="198"
        height="298"
        fill="none"
        stroke="black"
        stroke-width="2"
        rx="0"
        ry="0"
      />
      <line x1="1" y1="150" x2="199" y2="150" stroke="black" stroke-width="2" />
      <line x1="100" y1="1" x2="100" y2="150" stroke="black" stroke-width="2" />
    </svg>
  ),
  four: (
    <svg
      width="200"
      height="300"
      viewBox="0 0 200 300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="198"
        height="298"
        fill="none"
        stroke="black"
        stroke-width="2"
        rx="0"
        ry="0"
      />
      <line x1="1" y1="150" x2="199" y2="150" stroke="black" stroke-width="2" />
      <line x1="100" y1="1" x2="100" y2="299" stroke="black" stroke-width="2" />
    </svg>
  ),
  nine: (
    <svg
      width="200"
      height="300"
      viewBox="0 0 200 300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="198"
        height="298"
        fill="none"
        stroke="black"
        stroke-width="2"
        rx="0"
        ry="0"
      />
      <line x1="1" y1="100" x2="199" y2="100" stroke="black" stroke-width="2" />
      <line x1="1" y1="200" x2="199" y2="200" stroke="black" stroke-width="2" />
      <line x1="67" y1="1" x2="67" y2="299" stroke="black" stroke-width="2" />
      <line x1="133" y1="1" x2="133" y2="299" stroke="black" stroke-width="2" />
    </svg>
  ),
  four_sized: (
    <svg
      width="200"
      height="300"
      viewBox="0 0 200 300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="198"
        height="298"
        fill="none"
        stroke="black"
        stroke-width="2"
      />
      <line x1="1" y1="150" x2="199" y2="150" stroke="black" stroke-width="2" />
      <line x1="120" y1="1" x2="120" y2="150" stroke="black" stroke-width="2" />
      <line x1="80" y1="150" x2="80" y2="299" stroke="black" stroke-width="2" />
    </svg>
  ),
  six_sized: (
    <svg
      width="200"
      height="300"
      viewBox="0 0 200 300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="198"
        height="298"
        fill="none"
        stroke="black"
        stroke-width="2"
      />
      <line x1="1" y1="100" x2="199" y2="100" stroke="black" stroke-width="2" />
      <line x1="1" y1="200" x2="199" y2="200" stroke="black" stroke-width="2" />
      <line x1="120" y1="1" x2="120" y2="100" stroke="black" stroke-width="2" />
      <line x1="80" y1="100" x2="80" y2="200" stroke="black" stroke-width="2" />
      <line
        x1="120"
        y1="200"
        x2="120"
        y2="299"
        stroke="black"
        stroke-width="2"
      />
    </svg>
  ),
};

export const layoutsSvgPreviewsH = {
  twoHorizontal: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="297mm"
      height="210mm"
      viewBox="0 0 297 210"
      role="img"
      aria-labelledby="t7 d7"
    >
      <g fill="none" stroke="black" stroke-width="1">
        <rect x="1" y="1" width="295" height="208" />
        <rect id="item-1" x="1" y="1" width="147.5" height="208" />
        <rect id="item-2" x="148.5" y="1" width="147.5" height="208" />
      </g>
    </svg>
  ),

  threeHorizontal: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="297mm"
      height="210mm"
      viewBox="0 0 297 210"
      role="img"
      aria-labelledby="t6 d6"
    >
      <g fill="none" stroke="black" stroke-width="1">
        <rect x="1" y="1" width="295" height="208" />
        <rect id="item-1" x="1" y="1" width="196.666667" height="208" />
        <rect id="item-2" x="197.666667" y="1" width="98.333333" height="104" />
        <rect
          id="item-3"
          x="197.666667"
          y="105"
          width="98.333333"
          height="104"
        />
      </g>
    </svg>
  ),
  threeBottomTriangle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="297mm"
      height="210mm"
      viewBox="0 0 297 210"
      role="img"
      aria-labelledby="t5 d5"
    >
      <g fill="none" stroke="black" stroke-width="1">
        <rect x="1" y="1" width="295" height="208" />
        <rect id="item-1" x="1" y="1" width="98.333333" height="104" />
        <rect id="item-2" x="1" y="105" width="98.333333" height="104" />
        <rect id="item-3" x="99.333333" y="1" width="196.666667" height="208" />
      </g>
    </svg>
  ),
  threeTopTriangle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="297mm"
      height="210mm"
      viewBox="0 0 297 210"
      role="img"
      aria-labelledby="t4 d4"
    >
      <g fill="none" stroke="black" stroke-width="1">
        <rect x="1" y="1" width="295" height="208" />
        <rect id="item-1" x="1" y="1" width="147.5" height="104" />
        <rect id="item-2" x="148.5" y="1" width="147.5" height="104" />
        <rect id="item-3" x="1" y="105" width="147.5" height="104" />
        <rect id="item-4" x="148.5" y="105" width="147.5" height="104" />
      </g>
    </svg>
  ),
  four: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="297mm"
      height="210mm"
      viewBox="0 0 297 210"
      role="img"
      aria-labelledby="t3 d3"
    >
      <g fill="none" stroke="black" stroke-width="1">
        <rect x="1" y="1" width="295" height="208" />
        <rect id="item-1" x="1" y="1" width="147.5" height="138.666667" />
        <rect id="item-2" x="148.5" y="1" width="147.5" height="69.333333" />
        <rect
          id="item-3"
          x="1"
          y="139.666667"
          width="147.5"
          height="69.333333"
        />
        <rect
          id="item-4"
          x="148.5"
          y="70.333333"
          width="147.5"
          height="138.666667"
        />
      </g>
    </svg>
  ),

  nine: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="297mm"
      height="210mm"
      viewBox="0 0 297 210"
      role="img"
      aria-labelledby="t d"
    >
      <g fill="none" stroke="black" stroke-width="1">
        <rect x="1" y="1" width="295" height="208" />
        <rect id="item-1" x="1" y="1" width="98.333333" height="69.333333" />
        <rect
          id="item-2"
          x="99.333333"
          y="1"
          width="98.333333"
          height="69.333333"
        />
        <rect
          id="item-3"
          x="197.666667"
          y="1"
          width="98.333333"
          height="69.333333"
        />
        <rect
          id="item-4"
          x="1"
          y="70.333333"
          width="98.333333"
          height="69.333333"
        />
        <rect
          id="item-5"
          x="99.333333"
          y="70.333333"
          width="98.333333"
          height="69.333333"
        />
        <rect
          id="item-6"
          x="197.666667"
          y="70.333333"
          width="98.333333"
          height="69.333333"
        />
        <rect
          id="item-7"
          x="1"
          y="139.666667"
          width="98.333333"
          height="69.333333"
        />
        <rect
          id="item-8"
          x="99.333333"
          y="139.666667"
          width="98.333333"
          height="69.333333"
        />
        <rect
          id="item-9"
          x="197.666667"
          y="139.666667"
          width="98.333333"
          height="69.333333"
        />
      </g>
    </svg>
  ),

  four_sized: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="297mm"
      height="210mm"
      viewBox="0 0 297 210"
      role="img"
      aria-labelledby="t2 d2"
    >
      <g fill="none" stroke="black" stroke-width="1">
        <rect x="1" y="1" width="295" height="208" />
        <rect id="item-1" x="1" y="1" width="98.333333" height="104" />
        <rect id="item-2" x="99.333333" y="1" width="98.333333" height="104" />
        <rect id="item-3" x="197.666667" y="1" width="98.333333" height="104" />
        <rect id="item-4" x="1" y="105" width="98.333333" height="104" />
        <rect
          id="item-5"
          x="99.333333"
          y="105"
          width="98.333333"
          height="104"
        />
        <rect
          id="item-6"
          x="197.666667"
          y="105"
          width="98.333333"
          height="104"
        />
      </g>
    </svg>
  ),
  six_sized: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="297mm"
      height="210mm"
      viewBox="0 0 297 210"
      role="img"
      aria-labelledby="t1 d1"
    >
      <g fill="none" stroke="black" stroke-width="1">
        <rect x="1" y="1" width="295" height="208" />
        <rect id="item-1" x="1" y="1" width="98.333333" height="69.333333" />
        <rect
          id="item-2"
          x="99.333333"
          y="1"
          width="98.333333"
          height="138.666667"
        />
        <rect
          id="item-3"
          x="1"
          y="70.333333"
          width="98.333333"
          height="138.666667"
        />
        <rect
          id="item-4"
          x="99.333333"
          y="139.666667"
          width="98.333333"
          height="69.333333"
        />
        <rect
          id="item-5"
          x="197.666667"
          y="1"
          width="98.333333"
          height="69.333333"
        />
        <rect
          id="item-6"
          x="197.666667"
          y="70.333333"
          width="98.333333"
          height="138.666667"
        />
      </g>
    </svg>
  ),
};
